// DEV CHANGES ON 16 DESEMBER 2024 tes

import 'moment/locale/id';
import 'styles/DeliveryStatus/index.css';

import { Button, Card, Col, Row } from 'antd';
import {
  EnumContenTrackingDelivery,
  EnumHeaderTrackingDelivery,
} from 'module/DeliveryStatus/Container/EnumTrackingDelivery';

import ModalMaterial from 'materials/ModalMaterial';
import React from 'react';
import bgNoDataHistoryDelivery from 'image/bgNoDataHistoryDelivery.png';
import moment from 'moment';

moment.locale('id');

interface IProps {
  History: any;
  visible: any;
  typeToggle: any;
  getImageHistory: any;
  getSignatureHistory: any;
  handleModalImage: any;
  handleModalSignature: any;
  handleCloseModal: any;
}
export default function TrackingCardComponent({
  History,
  visible,
  typeToggle,
  getImageHistory,
  getSignatureHistory,
  handleModalImage,
  handleModalSignature,
  handleCloseModal,
}: IProps) {
  const data = History;
  const count = data.length - 1;
  const styles = {
    cardBody: {
      maxHeight: '420px',
      overflow: 'auto',
    },
  };
  const showImgValue = (img: any) => {
    if (img !== null) {
      const showImgValue =
        img.substring(0, 4) !== 'http' ? `data:image/jpeg;base64,${img}` : img;
      return showImgValue;
    } else {
      return img;
    }
  };
  return (
    <div style={{ height: '100%' }}>
      <div>
        {typeToggle === 'signatureHistory' ? (
          <ModalMaterial
            className={''}
            width={'40%'}
            style={{ paddingTop: '20px' }}
            teksTitle={'SIGNATURE'}
            visible={
              visible === true && typeToggle === 'signatureHistory'
                ? true
                : false
            }
            onCancel={handleCloseModal}
            content={
              <div>
                <div>
                  <img
                    className="image-gallery-slide"
                    alt="Signature History"
                    src={`data:image/jpeg;base64,${getSignatureHistory}`}
                  />
                </div>
              </div>
            }
          />
        ) : typeToggle === 'imageHistory' ? (
          <ModalMaterial
            className={''}
            width={'40%'}
            style={{ paddingTop: '20px' }}
            teksTitle={'FOTO'}
            visible={
              visible === true && typeToggle === 'imageHistory' ? true : false
            }
            onCancel={handleCloseModal}
            content={
              <div>
                <img
                  className="image-gallery-slide"
                  src={showImgValue(getImageHistory)}
                  alt="History"
                />
              </div>
            }
          />
        ) : (
          ''
        )}
      </div>
      <Card
        bodyStyle={styles.cardBody}
        style={{ borderRadius: '10px', height: '520px', maxHeight: '100%' }}
        title={
          <div>
            <span style={{ fontSize: 14 }}>
              <b
                style={{
                  color: '#11BEFF',
                  paddingLeft: '15px',
                  fontSize: 15,
                }}
              >
                Riwayat Pengiriman
              </b>
            </span>
          </div>
        }
      >
        {History.length === 0 ? (
          <div className="textAlignCenter">
            <img
              className="historyImg"
              alt="Data History Delivery"
              src={bgNoDataHistoryDelivery}
            />
          </div>
        ) : (
          data.map(
            (i: any, index: any) =>
              i.itemStatus !== "Attempt" && i.deliveryStatus !== "UploadProcess" && i.itemStatus !== "DownloadCourier" && (
                <Row className={index === count ? '' : 'line'}>
                  <Col span={5}>
                    <div
                      style={{
                        borderRadius: '4px',
                        background:
                          i.position === 2 && index !== 0
                            ? '#fb8c00'
                            : i.position > 2 && index !== 0
                            ? '#FF5858'
                            : index === 0
                            ? '#F5F5F5'
                            : '#7956EE',
                        textAlign: 'center',
                      }}
                    >
                      <span
                        style={{
                          fontSize: 13,
                          color:
                            index === 0 &&
                            i.itemStatus === 'Resend' &&
                            i.position > 2
                              ? '#000000'
                              : index === 0 &&
                                i.itemStatus === 'Resend' &&
                                i.position <= 2
                              ? '#000000'
                              : index === 0 && i.itemStatus !== 'Resend'
                              ? '#000000'
                              : '#FFFFFF',
                        }}
                      >
                        <div>
                          {moment(i.date ?? i.timeStamp).format('DD-MMM')}
                        </div>
                        <div>
                          {moment(i.date ?? i.timeStamp).format('HH:mm')}
                        </div>
                      </span>
                    </div>
                  </Col>
                  <Col span={19}>
                    <div style={{ paddingBottom: '15px', marginLeft: '15px' }}>
                      <div>
                        <div>
                          <b style={{ color: '#969696' }}>
                            {EnumHeaderTrackingDelivery(i)}
                          </b>
                        </div>
                        <div>
                          <Row>
                            <Col span={24}>
                              <div style={{ color: 'black' }}>
                                {EnumContenTrackingDelivery(i)}
                              </div>
                            </Col>
                          </Row>
                        </div>
                        <div>
                          {i.signature &&
                          i.deliveryStatus !== 'Return' &&
                          i.deliveryStatus !== 'Return3x' ? (
                            <Button
                              type="link"
                              style={{ paddingRight: '10px' }}
                              onClick={() => handleModalSignature(i.signature)}
                            >
                              Lihat TTD
                            </Button>
                          ) : null}
                          {i.image === null ? (
                            ''
                          ) : (
                            <Button
                              type="link"
                              onClick={() => handleModalImage(i.image)}
                            >
                              Lihat Foto
                            </Button>
                          )}
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              )
          )
        )}
      </Card>
    </div>
  );
}
